import axiosInstance from "../config/axiosInstance";

const FILENAME_FROM_HEADER = /filename="?([^"]+)"?/i;

/**
 * Baixa uma planilha gerada pelo backend.
 *
 * O endpoint responde com o binário do xlsx, então a requisição precisa sair
 * como blob e o nome do arquivo vem no Content-Disposition (com fallback local
 * quando o header não é exposto pelo CORS).
 */
export const downloadSpreadsheet = async (path, params = {}, fallbackName = "export") => {
  const response = await axiosInstance.get(path, {
    params,
    responseType: "blob",
  });

  const disposition = response?.headers?.["content-disposition"] || "";
  const match = FILENAME_FROM_HEADER.exec(disposition);
  const stamp = new Date().toISOString().slice(0, 10);
  const fileName = match?.[1] || `${fallbackName}-${stamp}.xlsx`;

  const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = blobUrl;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(blobUrl);
};
